import {
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS,
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_SUCCEEDED,
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_FAILED,
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE,
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE_SUCCEEDED,
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE_FAILED,
  FETCHING_NEW_ACCOUNTS,
  FETCHING_NEW_ACCOUNTS_SUCCEEDED,
  FETCHING_NEW_ACCOUNTS_FAILED,
  FETCHING_CHURNED_ACCOUNTS,
  FETCHING_CHURNED_ACCOUNTS_SUCCEEDED,
  FETCHING_CHURNED_ACCOUNTS_FAILED,
  FETCHING_TRIAL_ACCOUNTS,
  FETCHING_TRIAL_ACCOUNTS_SUCCEEDED,
  FETCHING_TRIAL_ACCOUNTS_FAILED,
  FETCHING_SUSPENDED_ACCOUNTS,
  FETCHING_SUSPENDED_ACCOUNTS_SUCCEEDED,
  FETCHING_SUSPENDED_ACCOUNTS_FAILED,
  FETCHING_TERMINATED_ACCOUNTS,
  FETCHING_TERMINATED_ACCOUNTS_SUCCEEDED,
  FETCHING_TERMINATED_ACCOUNTS_FAILED,
  FETCHING_TOTAL_USERS,
  FETCHING_TOTAL_USERS_SUCCEEDED,
  FETCHING_TOTAL_USERS_FAILED,
  FETCHING_TOTAL_ASSETS,
  FETCHING_TOTAL_ASSETS_SUCCEEDED,
  FETCHING_TOTAL_ASSETS_FAILED,
  FETCHING_TOTAL_COLLECTIONS,
  FETCHING_TOTAL_COLLECTIONS_SUCCEEDED,
  FETCHING_TOTAL_COLLECTIONS_FAILED,
  FETCHING_TOTAL_STREAMS,
  FETCHING_TOTAL_STREAMS_SUCCEEDED,
  FETCHING_TOTAL_STREAMS_FAILED,
  FETCHING_WEEKLY_ACTIVE_USERS,
  FETCHING_WEEKLY_ACTIVE_USERS_SUCCEEDED,
  FETCHING_WEEKLY_ACTIVE_USERS_FAILED,
  FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE,
  FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE_SUCCEEDED,
  FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE_FAILED,
  FETCHING_MONTHLY_ACTIVE_USERS,
  FETCHING_MONTHLY_ACTIVE_USERS_SUCCEEDED,
  FETCHING_MONTHLY_ACTIVE_USERS_FAILED,
  FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE,
  FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE_SUCCEEDED,
  FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE_FAILED,
  FETCHING_INTEGRATIONS,
  FETCHING_INTEGRATIONS_SUCCEEDED,
  FETCHING_INTEGRATIONS_FAILED,
  FETCHING_STREAM_CREATION,
  FETCHING_STREAM_CREATION_SUCCEEDED,
  FETCHING_STREAM_CREATION_FAILED,
  FETCHING_ASSET_CREATION,
  FETCHING_ASSET_CREATION_SUCCEEDED,
  FETCHING_ASSET_CREATION_FAILED,
  FETCHING_COLLECTION_CREATION,
  FETCHING_COLLECTION_CREATION_SUCCEEDED,
  FETCHING_COLLECTION_CREATION_FAILED,
  FETCHING_ASSET_VIEWING,
  FETCHING_ASSET_VIEWING_SUCCEEDED,
  FETCHING_ASSET_VIEWING_FAILED,
  FETCHING_ASSET_SHARING,
  FETCHING_ASSET_SHARING_SUCCEEDED,
  FETCHING_ASSET_SHARING_FAILED,
  FETCHING_ADOPTION_ACCOUNTS,
  FETCHING_ADOPTION_ACCOUNTS_SUCCEEDED,
  FETCHING_ADOPTION_ACCOUNTS_FAILED,
  FETCHING_DAILY_ACTIVE_USERS,
  FETCHING_DAILY_ACTIVE_USERS_SUCCEEDED,
  FETCHING_DAILY_ACTIVE_USERS_FAILED,
  FETCHING_DAILY_ACTIVE_USERS_TIMELINE,
  FETCHING_DAILY_ACTIVE_USERS_TIMELINE_SUCCEEDED,
  FETCHING_DAILY_ACTIVE_USERS_TIMELINE_FAILED,
  FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_REQUEST,
  FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_SUCCEEDED,
  FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_FAILED,
  FETCHING_FLITEVIEW_LINK_OPEN_RATE_REQUEST,
  FETCHING_FLITEVIEW_LINK_OPEN_RATE_SUCCEEDED,
  FETCHING_FLITEVIEW_LINK_OPEN_RATE_FAILED,
  FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_REQUEST,
  FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_SUCCEEDED,
  FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_FAILED,
  FETCHING_FLITEVIEW_PERSONALISED_LINKS_REQUEST,
  FETCHING_FLITEVIEW_PERSONALISED_LINKS_SUCCEEDED,
  FETCHING_FLITEVIEW_PERSONALISED_LINKS_FAILED,
  FETCHING_FLITEVIEW_ANONYMOUS_LINKS_REQUEST,
  FETCHING_FLITEVIEW_ANONYMOUS_LINKS_SUCCEEDED,
  FETCHING_FLITEVIEW_ANONYMOUS_LINKS_FAILED,
  FETCHING_FLITEVIEW_SESSIONS_REQUEST,
  FETCHING_FLITEVIEW_SESSIONS_SUCCEEDED,
  FETCHING_FLITEVIEW_SESSIONS_FAILED,
  FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_REQUEST,
  FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_SUCCEEDED,
  FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_FAILED,
  FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_REQUEST,
  FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_SUCCEEDED,
  FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_FAILED,
  FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_REQUEST,
  FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_SUCCEEDED,
  FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_FAILED,
  FETCHING_FLITEVIEW_SESSIONS_COMPLETION_REQUEST,
  FETCHING_FLITEVIEW_SESSIONS_COMPLETION_SUCCEEDED,
  FETCHING_FLITEVIEW_SESSIONS_COMPLETION_FAILED,
  FETCHING_TOTAL_LEADS_REQUEST,
  FETCHING_TOTAL_LEADS_SUCCEEDED,
  FETCHING_TOTAL_LEADS_FAILED,
  FETCHING_WEEKLY_ADOPTION_MATRIX_REQUEST,
  FETCHING_WEEKLY_ADOPTION_MATRIX_SUCCEEDED,
  FETCHING_WEEKLY_ADOPTION_MATRIX_FAILED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_REQUEST,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_SUCCEEDED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_FAILED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_REQUEST,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_SUCCEEDED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_FAILED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_REQUEST,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_SUCCEEDED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_FAILED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_REQUEST,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_SUCCEEDED,
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_FAILED,
  FETCHING_WEEKLY_ADOPTION_LIST_REQUEST,
  FETCHING_WEEKLY_ADOPTION_LIST_SUCCEEDED,
  FETCHING_WEEKLY_ADOPTION_LIST_FAILED,
} from "constants/actionTypes.jsx";

import axios from "axios";
import buildUrl from "build-url";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;
const METRICS_BASE_URL = `${API_URL}/api/1.0/metrics`;

/** fetch accounts for dropdown */
export const fetchAdoptionAccounts = createAction(FETCHING_ADOPTION_ACCOUNTS);
export const fetchAdoptionAccountsSucceeded = createAction(
  FETCHING_ADOPTION_ACCOUNTS_SUCCEEDED
);
export const fetchAdoptionAccountsFailed = createAction(
  FETCHING_ADOPTION_ACCOUNTS_FAILED
);

function* fetchAdoptionAccountsSaga(action) {
  let url = buildUrl(`${METRICS_BASE_URL}/accounts/PAID`);
  const fetchAdoptionAccountsAPI = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAdoptionAccountsAPI);
    yield put(fetchAdoptionAccountsSucceeded(response));
  } catch (error) {
    yield put(fetchAdoptionAccountsFailed(error));
  }
}

/** fetch total accounts */
export const fetchTotalAccounts = createAction(
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS
);
const fetchingTotalAccountSucceeded = createAction(
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_SUCCEEDED
);
const fetchingTotalAccountFailed = createAction(
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_FAILED
);

function* fetchTotalAccountsSaga(action) {
  let { subscriptionType } = action.payload;
  let url = buildUrl(`${METRICS_BASE_URL}/accounts`, {
    path: `${subscriptionType}/count`,
  });
  const fetchTotalAccountsAPI = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchTotalAccountsAPI);
    yield put(fetchingTotalAccountSucceeded(response));
  } catch (error) {
    yield put(fetchingTotalAccountFailed(error));
  }
}

/** fetch total accounts */
export const fetchTotalAccountsTimeline = createAction(
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE
);
const fetchingTotalAccountTimelineSucceeded = createAction(
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE_SUCCEEDED
);
const fetchingTotalAccountTimelineFailed = createAction(
  FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE_FAILED
);

function* fetchTotalAccountsTimelineSaga(action) {
  let { from, to } = action.payload;
  let url = buildUrl(`${METRICS_BASE_URL}/timeline`);

  const fetchTotalAccountsAPI = () => {
    const data = {
      reference: "accounts.paid",
      from: from,
      to: to,
    };
    return axios({
      method: "POST",
      url: url,
      data: data,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchTotalAccountsAPI);
    yield put(fetchingTotalAccountTimelineSucceeded(response));
  } catch (error) {
    yield put(fetchingTotalAccountTimelineFailed(error));
  }
}

/** fetch new accounts */
export const fetchNewAccounts = createAction(FETCHING_NEW_ACCOUNTS);
const fetchingNewAccountSucceeded = createAction(
  FETCHING_NEW_ACCOUNTS_SUCCEEDED
);
const fetchingNewAccountFailed = createAction(FETCHING_NEW_ACCOUNTS_FAILED);

function* fetchNewAccountsSaga(action) {
  let { from, to } = action.payload;
  let url = buildUrl(`${METRICS_BASE_URL}/accounts`);
  const fetchNewAccountsAPI = () => {
    const data = {
      type: "NEW",
      from: from,
      to: to,
    };
    return axios({
      method: "POST",
      url: url,
      data: data,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchNewAccountsAPI);
    yield put(fetchingNewAccountSucceeded(response));
  } catch (error) {
    console.log(error);
    yield put(fetchingNewAccountFailed(error));
  }
}

/** fetch churned accounts */
export const fetchChurnedAccounts = createAction(FETCHING_CHURNED_ACCOUNTS);
const fetchingChurnedAccountSucceeded = createAction(
  FETCHING_CHURNED_ACCOUNTS_SUCCEEDED
);
const fetchingChurnedAccountFailed = createAction(
  FETCHING_CHURNED_ACCOUNTS_FAILED
);

function* fetchChurnedAccountsSaga(action) {
  let { from, to } = action.payload;
  let url = buildUrl(`${METRICS_BASE_URL}/accounts`);
  const fetchChurnedAccountsAPI = () => {
    const data = {
      type: "CHURNED",
      from: from,
      to: to,
    };
    return axios({
      method: "POST",
      url: url,
      data: data,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchChurnedAccountsAPI);
    yield put(fetchingChurnedAccountSucceeded(response));
  } catch (error) {
    yield put(fetchingChurnedAccountFailed(error));
  }
}
/** fetch Trail accounts */
export const fetchTrialAccounts = createAction(FETCHING_TRIAL_ACCOUNTS);
const fetchingTrialAccountSucceeded = createAction(
  FETCHING_TRIAL_ACCOUNTS_SUCCEEDED
);
const fetchingTrialAccountFailed = createAction(FETCHING_TRIAL_ACCOUNTS_FAILED);

function* fetchTrialAccountsSaga(action) {
  let { page, limit } = action.payload;
  let url = buildUrl(`${METRICS_BASE_URL}/accounts/trialExceededAccounts`);
  const fetchTrialAccountsAPI = () => {
    const params = {
      page,
      limit,
    };

    return axios({
      method: "GET",
      url,
      params: params,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchTrialAccountsAPI);
    yield put(fetchingTrialAccountSucceeded(response));
  } catch (error) {
    console.log(error);
    yield put(fetchingTriallAccountFailed(error));
  }
}

/** fetch Suspended accounts */
export const fetchSuspendedAccounts = createAction(FETCHING_SUSPENDED_ACCOUNTS);
const fetchingSuspendedAccountSucceeded = createAction(
  FETCHING_SUSPENDED_ACCOUNTS_SUCCEEDED
);
const fetchingSuspendedAccountFailed = createAction(FETCHING_SUSPENDED_ACCOUNTS_FAILED);

function* fetchSuspendedAccountsSaga(action) {
 let { page, limit } = action.payload;
  let url = buildUrl(`${METRICS_BASE_URL}/accounts/suspendedAccounts`);
  const fetchSuspendedAccountsAPI = () => {
   const params = {
      page,
      limit,
    };
    return axios({
      method: "GET",
      url,
      params: params,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchSuspendedAccountsAPI);
    yield put(fetchingSuspendedAccountSucceeded(response));
  } catch (error) {
    console.log(error);
    yield put(fetchingSuspendedAccountFailed(error));
  }
}

/** fetch Terminated accounts */
export const fetchTerminatedAccounts = createAction(FETCHING_TERMINATED_ACCOUNTS);
const fetchTerminatedAccountSucceeded = createAction(
  FETCHING_TERMINATED_ACCOUNTS_SUCCEEDED
);
const fetchingTerminatedAccountFailed = createAction(FETCHING_TERMINATED_ACCOUNTS_FAILED);

function* fetchTerminatedAccountsSaga(action) {
 let { page, limit } = action.payload;
  let url = buildUrl(`${METRICS_BASE_URL}/accounts/terminatedAccounts`);
  const fetchTerminatedAccountsAPI = () => {
   const params = {
      page,
      limit,
    };
    return axios({
      method: "GET",
      url,
      params: params,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchTerminatedAccountsAPI);
    yield put(fetchTerminatedAccountSucceeded(response));
  } catch (error) {
    console.log(error);
    yield put(fetchingTerminatedAccountFailed(error));
  }
}
/** fetch total users */
export const fetchTotalUsers = createAction(FETCHING_TOTAL_USERS);
const fetchingTotalUsersSucceeded = createAction(
  FETCHING_TOTAL_USERS_SUCCEEDED
);
const fetchingTotalUsersFailed = createAction(FETCHING_TOTAL_USERS_FAILED);

function* fetchTotalUsersSaga(action) {

  let filters = action.payload;
  filters.reference = "users.active";

  let url = buildUrl(`${METRICS_BASE_URL}/count`);

  const fetchTotalUsersAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchTotalUsersAPI);
    yield put(fetchingTotalUsersSucceeded(response));
  } catch (error) {
    yield put(fetchingTotalUsersFailed(error));
  }
}

/** fetch total assets */
export const fetchTotalAssets = createAction(FETCHING_TOTAL_ASSETS);
const fetchingTotalAssetsSucceeded = createAction(
  FETCHING_TOTAL_ASSETS_SUCCEEDED
);
const fetchingTotalAssetsFailed = createAction(FETCHING_TOTAL_ASSETS_FAILED);

function* fetchTotalAssetsSaga(action) {

  let filters = action.payload;
  filters.reference = "assets.total";

  let url = buildUrl(`${METRICS_BASE_URL}/count`);
  const fetchTotalAssetsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchTotalAssetsAPI);
    yield put(fetchingTotalAssetsSucceeded(response));
  } catch (error) {
    yield put(fetchingTotalAssetsFailed(error));
  }
}

/** fetch total Collections */
export const fetchTotalCollections = createAction(FETCHING_TOTAL_COLLECTIONS);
const fetchingTotalCollectionsSucceeded = createAction(
  FETCHING_TOTAL_COLLECTIONS_SUCCEEDED
);
const fetchingTotalCollectionsFailed = createAction(
  FETCHING_TOTAL_COLLECTIONS_FAILED
);

function* fetchTotalCollectionsSaga(action) {

  let filters = action.payload;
  filters.reference = "collections.total";

  let url = buildUrl(`${METRICS_BASE_URL}/count`);
  const fetchTotalCollectionsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchTotalCollectionsAPI);
    yield put(fetchingTotalCollectionsSucceeded(response));
  } catch (error) {
    yield put(fetchingTotalCollectionsFailed(error));
  }
}

/** fetch total assets */
export const fetchTotalStreams = createAction(FETCHING_TOTAL_STREAMS);
const fetchingTotalStreamsSucceeded = createAction(
  FETCHING_TOTAL_STREAMS_SUCCEEDED
);
const fetchingTotalStreamsFailed = createAction(FETCHING_TOTAL_STREAMS_FAILED);

function* fetchTotalStreamsSaga(action) {

  let filters = action.payload;
  filters.reference = "streams.total";

  let url = buildUrl(`${METRICS_BASE_URL}/count`);
  const fetchTotalStreamsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchTotalStreamsAPI);
    yield put(fetchingTotalStreamsSucceeded(response));
  } catch (error) {
    yield put(fetchingTotalStreamsFailed(error));
  }
}

/** fetch total leads */
export const fetchTotalLeads = createAction(FETCHING_TOTAL_LEADS_REQUEST);
const fetchingTotalLeadsSucceeded = createAction(
  FETCHING_TOTAL_LEADS_SUCCEEDED
);
const fetchingTotalLeadsFailed = createAction(FETCHING_TOTAL_LEADS_FAILED);

function* fetchTotalLeadsSaga(action) {

  let filters = action.payload;
  filters.reference = "leads.total";

  let url = buildUrl(`${METRICS_BASE_URL}/count`);
  const fetchTotalLeadsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchTotalLeadsAPI);
    yield put(fetchingTotalLeadsSucceeded(response));
  } catch (error) {
    yield put(fetchingTotalLeadsFailed(error));
  }
}

/** fetch daily active users */
export const fetchDailyActiveUsers = createAction(FETCHING_DAILY_ACTIVE_USERS);
const fetchingDailyActiveUsersSucceeded = createAction(
  FETCHING_DAILY_ACTIVE_USERS_SUCCEEDED
);
const fetchingDailyActiveUsersFailed = createAction(
  FETCHING_DAILY_ACTIVE_USERS_FAILED
);

function* fetchDailyActiveUsersSaga(action) {

  let filters = action.payload;
  filters.reference = "users.daily";

  let url = buildUrl(`${METRICS_BASE_URL}/active-users/count`, {
    queryParams: { activeUserType: "DAILY" },
  });
  const fetchDailyActiveUsersAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDailyActiveUsersAPI);
    yield put(fetchingDailyActiveUsersSucceeded(response));
  } catch (error) {
    yield put(fetchingDailyActiveUsersFailed(error));
  }
}

/** fetch daily active users timeline */
export const fetchDailyActiveUsersTimeline = createAction(
  FETCHING_DAILY_ACTIVE_USERS_TIMELINE
);
const fetchingDailyActiveUsersTimelineSucceeded = createAction(
  FETCHING_DAILY_ACTIVE_USERS_TIMELINE_SUCCEEDED
);
const fetchingDailyActiveUsersTimelineFailed = createAction(
  FETCHING_DAILY_ACTIVE_USERS_TIMELINE_FAILED
);

function* fetchDailyActiveUsersTimelineSaga(action) {

  let filters = action.payload;
  filters.reference = "users.daily";

  let url = buildUrl(`${METRICS_BASE_URL}/active-users/timeline`, {
    queryParams: { activeUserType: "DAILY" },
  });
  const fetchDailyActiveUsersTimelineAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDailyActiveUsersTimelineAPI);
    yield put(fetchingDailyActiveUsersTimelineSucceeded(response));
  } catch (error) {
    yield put(fetchingDailyActiveUsersTimelineFailed(error));
  }
}

/** fetch weekly active users */
export const fetchWeeklyActiveUsers = createAction(
  FETCHING_WEEKLY_ACTIVE_USERS
);
const fetchingWeeklyActiveUsersSucceeded = createAction(
  FETCHING_WEEKLY_ACTIVE_USERS_SUCCEEDED
);
const fetchingWeeklyActiveUsersFailed = createAction(
  FETCHING_WEEKLY_ACTIVE_USERS_FAILED
);

function* fetchWeeklyActiveUsersSaga(action) {

  let filters = action.payload;
  filters.reference = "users.weekly";

  let url = buildUrl(`${METRICS_BASE_URL}/active-users/count`, {
    queryParams: { activeUserType: "WEEKLY" },
  });
  const fetchWeeklyActiveUsersAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchWeeklyActiveUsersAPI);
    yield put(fetchingWeeklyActiveUsersSucceeded(response));
  } catch (error) {
    yield put(fetchingWeeklyActiveUsersFailed(error));
  }
}

/** fetch weekly active users */
export const fetchWeeklyActiveUsersTimeline = createAction(
  FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE
);
const fetchingWeeklyActiveUsersTimelineSucceeded = createAction(
  FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE_SUCCEEDED
);
const fetchingWeeklyActiveUsersTimelineFailed = createAction(
  FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE_FAILED
);

function* fetchWeeklyActiveUsersTimelineSaga(action) {

  let filters = action.payload;
  filters.reference = "users.weekly";

  let url = buildUrl(`${METRICS_BASE_URL}/active-users/timeline`, {
    queryParams: { activeUserType: "WEEKLY" },
  });
  const fetchWeeklyActiveUsersTimelineAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchWeeklyActiveUsersTimelineAPI);
    yield put(fetchingWeeklyActiveUsersTimelineSucceeded(response));
  } catch (error) {
    yield put(fetchingWeeklyActiveUsersTimelineFailed(error));
  }
}

/** fetch monthly active users */
export const fetchMonthlyActiveUsers = createAction(
  FETCHING_MONTHLY_ACTIVE_USERS
);
const fetchingMonthlyActiveUsersSucceeded = createAction(
  FETCHING_MONTHLY_ACTIVE_USERS_SUCCEEDED
);
const fetchingMonthlyActiveUsersFailed = createAction(
  FETCHING_MONTHLY_ACTIVE_USERS_FAILED
);

function* fetchMonthlyActiveUsersSaga(action) {

  let filters = action.payload;
  filters.reference = "users.monthly";

  let url = buildUrl(`${METRICS_BASE_URL}/active-users/count`, {
    queryParams: { activeUserType: "MONTHLY" },
  });

  const fetchMonthlyActiveUsersAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchMonthlyActiveUsersAPI);
    yield put(fetchingMonthlyActiveUsersSucceeded(response));
  } catch (error) {
    yield put(fetchingMonthlyActiveUsersFailed(error));
  }
}

/** fetch monthly active users */
export const fetchMonthlyActiveUsersTimeline = createAction(
  FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE
);
const fetchingMonthlyActiveUsersTimelineSucceeded = createAction(
  FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE_SUCCEEDED
);
const fetchingMonthlyActiveUsersTimelineFailed = createAction(
  FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE_FAILED
);

function* fetchMonthlyActiveUsersTimelineSaga(action) {

  let filters = action.payload;
  filters.reference = "users.monthly";

  let url = buildUrl(`${METRICS_BASE_URL}/active-users/timeline`, {
    queryParams: { activeUserType: "MONTHLY" },
  });

  const fetchMonthlyActiveUsersTimelineAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchMonthlyActiveUsersTimelineAPI);
    yield put(fetchingMonthlyActiveUsersTimelineSucceeded(response));
  } catch (error) {
    yield put(fetchingMonthlyActiveUsersTimelineFailed(error));
  }
}

/** fetch integrations */
export const fetchIntegrations = createAction(FETCHING_INTEGRATIONS);
const fetchingIntegrationsSucceeded = createAction(
  FETCHING_INTEGRATIONS_SUCCEEDED
);
const fetchingIntegrationsFailed = createAction(FETCHING_INTEGRATIONS_FAILED);

function* fetchIntegrationsSaga(action) {

  let filters = action.payload;
  filters.reference = "";

  let url = buildUrl(`${METRICS_BASE_URL}/integrations`);
  const fetchIntegrationsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchIntegrationsAPI);
    yield put(fetchingIntegrationsSucceeded(response));
  } catch (error) {
    yield put(fetchingIntegrationsFailed(error));
  }
}

/** fetch stream creation */
export const fetchStreamCreation = createAction(FETCHING_STREAM_CREATION);
const fetchingStreamCreationSucceeded = createAction(
  FETCHING_STREAM_CREATION_SUCCEEDED
);
const fetchingStreamCreationFailed = createAction(
  FETCHING_STREAM_CREATION_FAILED
);

function* fetchStreamCreationSaga(action) {

  let filters = action.payload;
  filters.reference = "streams.weekly";

  let url = buildUrl(`${METRICS_BASE_URL}/timeline`);
  const fetchStreamCreationAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchStreamCreationAPI);
    yield put(fetchingStreamCreationSucceeded(response));
  } catch (error) {
    yield put(fetchingStreamCreationFailed(error));
  }
}

/** fetch asset creation */
export const fetchAssetCreation = createAction(FETCHING_ASSET_CREATION);
const fetchingAssetCreationSucceeded = createAction(
  FETCHING_ASSET_CREATION_SUCCEEDED
);
const fetchingAssetCreationFailed = createAction(
  FETCHING_ASSET_CREATION_FAILED
);

function* fetchAssetCreationSaga(action) {

  let filters = action.payload;
  filters.reference = "assets.weekly";

  let url = buildUrl(`${METRICS_BASE_URL}/timeline`);
  const fetchAssetCreationAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssetCreationAPI);
    yield put(fetchingAssetCreationSucceeded(response));
  } catch (error) {
    yield put(fetchingAssetCreationFailed(error));
  }
}

/** fetch collection creation */
export const fetchCollectionCreation = createAction(
  FETCHING_COLLECTION_CREATION
);
const fetchingCollectionCreationSucceeded = createAction(
  FETCHING_COLLECTION_CREATION_SUCCEEDED
);
const fetchingCollectionCreationFailed = createAction(
  FETCHING_COLLECTION_CREATION_FAILED
);

function* fetchCollectionCreationSaga(action) {

  let filters = action.payload;
  filters.reference = "collections.weekly";

  let url = buildUrl(`${METRICS_BASE_URL}/timeline`);
  const fetchCollectionCreationAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchCollectionCreationAPI);
    yield put(fetchingCollectionCreationSucceeded(response));
  } catch (error) {
    yield put(fetchingCollectionCreationFailed(error));
  }
}

/** fetch asset viewing */
export const fetchAssetViewing = createAction(FETCHING_ASSET_VIEWING);
const fetchingAssetViewingSucceeded = createAction(
  FETCHING_ASSET_VIEWING_SUCCEEDED
);
const fetchingAssetViewingFailed = createAction(FETCHING_ASSET_VIEWING_FAILED);

function* fetchAssetViewingSaga(action) {

  let filters = action.payload;
  filters.reference = "assets.viewedWeekly";

  let url = buildUrl(`${METRICS_BASE_URL}/timeline`);
  const fetchAssetViewingAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssetViewingAPI);
    yield put(fetchingAssetViewingSucceeded(response));
  } catch (error) {
    yield put(fetchingAssetViewingFailed(error));
  }
}

/** fetch asset sharing */
export const fetchAssetSharing = createAction(FETCHING_ASSET_SHARING);
const fetchingAssetSharingSucceeded = createAction(
  FETCHING_ASSET_SHARING_SUCCEEDED
);
const fetchingAssetSharingFailed = createAction(FETCHING_ASSET_SHARING_FAILED);

function* fetchAssetSharingSaga(action) {

  let filters = action.payload;
  filters.reference = "assets.sharedWeekly";

  let url = buildUrl(`${METRICS_BASE_URL}/timeline`);
  const fetchAssetSharingAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAssetSharingAPI);
    yield put(fetchingAssetSharingSucceeded(response));
  } catch (error) {
    yield put(fetchingAssetSharingFailed(error));
  }
}

// fliteview - shares email open rate metrics
export const fetchEmailOpenRate = createAction(
  FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_REQUEST
);
const fetchingEmailOpenRateSucceeded = createAction(
  FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_SUCCEEDED
);
const fetchingEmailOpenRateFailed = createAction(
  FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_FAILED
);

function* fetchEmailOpenRateSaga(action) {

  let filters = action.payload;
  filters.reference = "shares.avg_email_open_rate";

  let url = buildUrl(`${METRICS_BASE_URL}/email-open-rate`);

  const fetchEmailOpenRateAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEmailOpenRateAPI);
    yield put(fetchingEmailOpenRateSucceeded(response));
  } catch (error) {
    yield put(fetchingEmailOpenRateFailed(error));
  }
}

// fliteview - shares link open rate metrics
export const fetchLinkOpenRate = createAction(
  FETCHING_FLITEVIEW_LINK_OPEN_RATE_REQUEST
);
const fetchingLinkOpenRateSucceeded = createAction(
  FETCHING_FLITEVIEW_LINK_OPEN_RATE_SUCCEEDED
);
const fetchingLinkOpenRateFailed = createAction(
  FETCHING_FLITEVIEW_LINK_OPEN_RATE_FAILED
);

function* fetchLinkOpenRateSaga(action) {

  let filters = action.payload;
  filters.reference = "shares.avg_link_open_rate";

  let url = buildUrl(`${METRICS_BASE_URL}/link-click-rate`);

  const fetchLinkOpenRateAPI = () => {

    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLinkOpenRateAPI);
    yield put(fetchingLinkOpenRateSucceeded(response));
  } catch (error) {
    yield put(fetchingLinkOpenRateFailed(error));
  }
}

// fliteview - shares average time spent metrics
export const fetchAverageTimeSpent = createAction(
  FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_REQUEST
);
const fetchingAverageTimeSpentSucceeded = createAction(
  FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_SUCCEEDED
);
const fetchingAverageTimeSpentFailed = createAction(
  FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_FAILED
);

function* fetchAverageTimeSpentSaga(action) {

  let filters = action.payload;
  filters.reference = "sessions.avg_time_spent";

  let url = buildUrl(`${METRICS_BASE_URL}/average-time-spent`);

  const fetchAverageTimeSpentAPI = () => {

    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAverageTimeSpentAPI);
    yield put(fetchingAverageTimeSpentSucceeded(response));
  } catch (error) {
    yield put(fetchingAverageTimeSpentFailed(error));
  }
}

// fliteview - personalised links
export const fetchPersonalisedLinks = createAction(
  FETCHING_FLITEVIEW_PERSONALISED_LINKS_REQUEST
);
const fetchingPersonalisedLinksSucceeded = createAction(
  FETCHING_FLITEVIEW_PERSONALISED_LINKS_SUCCEEDED
);
const fetchingPersonalisedLinksFailed = createAction(
  FETCHING_FLITEVIEW_PERSONALISED_LINKS_FAILED
);

function* fetchPersonalisedLinksSaga(action) {

  let filters = action.payload;
  filters.reference = "links.personalised";

  let url = buildUrl(`${METRICS_BASE_URL}/count`);

  const fetchPersonalisedLinksAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPersonalisedLinksAPI);
    yield put(fetchingPersonalisedLinksSucceeded(response));
  } catch (error) {
    yield put(fetchingPersonalisedLinksFailed(error));
  }
}

// fliteview - anonymous links
export const fetchAnonymousLinks = createAction(
  FETCHING_FLITEVIEW_ANONYMOUS_LINKS_REQUEST
);
const fetchingAnonymousLinksSucceeded = createAction(
  FETCHING_FLITEVIEW_ANONYMOUS_LINKS_SUCCEEDED
);
const fetchingAnonymousLinksFailed = createAction(
  FETCHING_FLITEVIEW_ANONYMOUS_LINKS_FAILED
);

function* fetchAnonymousLinksSaga(action) {

  let filters = action.payload;
  filters.reference = "links.anonymous";

  let url = buildUrl(`${METRICS_BASE_URL}/count`);

  const fetchAnonymousLinksAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAnonymousLinksAPI);
    yield put(fetchingAnonymousLinksSucceeded(response));
  } catch (error) {
    yield put(fetchingAnonymousLinksFailed(error));
  }
}

// fliteview - sessions metrics
export const fetchSessions = createAction(FETCHING_FLITEVIEW_SESSIONS_REQUEST);
const fetchingSessionsSucceeded = createAction(
  FETCHING_FLITEVIEW_SESSIONS_SUCCEEDED
);
const fetchingSessionsFailed = createAction(FETCHING_FLITEVIEW_SESSIONS_FAILED);

function* fetchSessionsSaga(action) {

  let filters = action.payload;
  filters.reference = "sessions.created";

  let url = buildUrl(`${METRICS_BASE_URL}/count`);

  const fetchSessionsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchSessionsAPI);
    yield put(fetchingSessionsSucceeded(response));
  } catch (error) {
    yield put(fetchingSessionsFailed(error));
  }
}

// fliteview - personalised sessions metrics
export const fetchPersonalisedSessions = createAction(
  FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_REQUEST
);
const fetchingPersonalisedSessionsSucceeded = createAction(
  FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_SUCCEEDED
);
const fetchingPersonalisedSessionsFailed = createAction(
  FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_FAILED
);

function* fetchPersonalisedSessionsSaga(action) {

  let filters = action.payload;
  filters.reference = "sessions.personalised";

  let url = buildUrl(`${METRICS_BASE_URL}/count`);

  const fetchPersonalisedSessionsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPersonalisedSessionsAPI);
    yield put(fetchingPersonalisedSessionsSucceeded(response));
  } catch (error) {
    yield put(fetchingPersonalisedSessionsFailed(error));
  }
}

// fliteview - anonymous sessions metrics
export const fetchAnonymousSessions = createAction(
  FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_REQUEST
);
const fetchingAnonymousSessionsSucceeded = createAction(
  FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_SUCCEEDED
);
const fetchingAnonymousSessionsFailed = createAction(
  FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_FAILED
);

function* fetchAnonymousSessionsSaga(action) {

  let filters = action.payload;
  filters.reference = "sessions.anonymous";

  let url = buildUrl(`${METRICS_BASE_URL}/count`);

  const fetchAnonymousSessionsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAnonymousSessionsAPI);
    yield put(fetchingAnonymousSessionsSucceeded(response));
  } catch (error) {
    yield put(fetchingAnonymousSessionsFailed(error));
  }
}

// fliteview - unique visitors metrics
export const fetchUniqueVisitors = createAction(
  FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_REQUEST
);
const fetchingUniqueVisitorsSucceeded = createAction(
  FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_SUCCEEDED
);
const fetchingUniqueVisitorsFailed = createAction(
  FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_FAILED
);

function* fetchUniqueVisitorsSaga(action) {

  let filters = action.payload;
  filters.reference = "sessions.visitors";

  let url = buildUrl(`${METRICS_BASE_URL}/visitors/count`);

  const fetchUniqueVisitorsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchUniqueVisitorsAPI);
    yield put(fetchingUniqueVisitorsSucceeded(response));
  } catch (error) {
    yield put(fetchingUniqueVisitorsFailed(error));
  }
}

// fliteview - sessions completion metrics
export const fetchSessionsCompletion = createAction(
  FETCHING_FLITEVIEW_SESSIONS_COMPLETION_REQUEST
);
const fetchingSessionsCompletionSucceeded = createAction(
  FETCHING_FLITEVIEW_SESSIONS_COMPLETION_SUCCEEDED
);
const fetchingSessionsCompletionFailed = createAction(
  FETCHING_FLITEVIEW_SESSIONS_COMPLETION_FAILED
);

function* fetchSessionsCompletionSaga(action) {
  let filters = action.payload;
  filters.reference = "sessions.completion";

  let url = buildUrl(`${METRICS_BASE_URL}/completion`);

  const fetchSessionsCompletionAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchSessionsCompletionAPI);
    yield put(fetchingSessionsCompletionSucceeded(response));
  } catch (error) {
    yield put(fetchingSessionsCompletionFailed(error));
  }
}

// wau adoption matrix
export const fetchWeeklyAdoptionMatrix = createAction(
  FETCHING_WEEKLY_ADOPTION_MATRIX_REQUEST
);
const fetchingWeeklyAdoptionMatrixSucceeded = createAction(
  FETCHING_WEEKLY_ADOPTION_MATRIX_SUCCEEDED
);
const fetchingWeeklyAdoptionMatrixFailed = createAction(
  FETCHING_WEEKLY_ADOPTION_MATRIX_FAILED
);

function* fetchWeeklyAdoptionMatrixSaga(action) {
  let { from, to } = action.payload;

  let url = buildUrl(`${METRICS_BASE_URL}/weekly-adoption/matrix`);

  const fetchWeeklyAdoptionMatrixAPI = () => {
    const data = {
      from: from,
      to: to,
    };
    return axios({
      method: "POST",
      url: url,
      data: data,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchWeeklyAdoptionMatrixAPI);
    yield put(fetchingWeeklyAdoptionMatrixSucceeded(response));
  } catch (error) {
    yield put(fetchingWeeklyAdoptionMatrixFailed(error));
  }
}

// wau adoption timeline
export const fetchWeeklyAdoptionTimelineC1 = createAction(
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_REQUEST
);
const fetchingWeeklyAdoptionTimelineC1Succeeded = createAction(
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_SUCCEEDED
);
const fetchingWeeklyAdoptionTimelineC1Failed = createAction(
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_FAILED
);

function* fetchWeeklyAdoptionTimelineC1Saga(action) {
  let { from, to } = action.payload;

  let url = buildUrl(`${METRICS_BASE_URL}/weekly-adoption/timeline`);

  const fetchWeeklyAdoptionTimelineC1API = () => {
    const params = {
      category: "CATEGORY_0_25",
    };

    const data = {
      from: from,
      to: to,
    };
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: data,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchWeeklyAdoptionTimelineC1API);
    yield put(fetchingWeeklyAdoptionTimelineC1Succeeded(response));
  } catch (error) {
    yield put(fetchingWeeklyAdoptionTimelineC1Failed(error));
  }
}

export const fetchWeeklyAdoptionTimelineC2 = createAction(
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_REQUEST
);
const fetchingWeeklyAdoptionTimelineC2Succeeded = createAction(
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_SUCCEEDED
);
const fetchingWeeklyAdoptionTimelineC2Failed = createAction(
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_FAILED
);

function* fetchWeeklyAdoptionTimelineC2Saga(action) {
  let { from, to } = action.payload;

  let url = buildUrl(`${METRICS_BASE_URL}/weekly-adoption/timeline`);

  const fetchWeeklyAdoptionTimelineAC2PI = () => {
    const params = {
      category: "CATEGORY_25_50",
    };

    const data = {
      from: from,
      to: to,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: data,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchWeeklyAdoptionTimelineAC2PI);
    yield put(fetchingWeeklyAdoptionTimelineC2Succeeded(response));
  } catch (error) {
    yield put(fetchingWeeklyAdoptionTimelineC2Failed(error));
  }
}

export const fetchWeeklyAdoptionTimelineC3 = createAction(
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_REQUEST
);
const fetchingWeeklyAdoptionTimelineC3Succeeded = createAction(
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_SUCCEEDED
);
const fetchingWeeklyAdoptionTimelineC3Failed = createAction(
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_FAILED
);

function* fetchWeeklyAdoptionTimelineC3Saga(action) {
  let { from, to } = action.payload;

  let url = buildUrl(`${METRICS_BASE_URL}/weekly-adoption/timeline`);

  const fetchWeeklyAdoptionTimelineC3API = () => {
    const params = {
      category: "CATEGORY_50_75",
    };

    const data = {
      from: from,
      to: to,
    };
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: data,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchWeeklyAdoptionTimelineC3API);
    yield put(fetchingWeeklyAdoptionTimelineC3Succeeded(response));
  } catch (error) {
    yield put(fetchingWeeklyAdoptionTimelineC3Failed(error));
  }
}

export const fetchWeeklyAdoptionTimelineC4 = createAction(
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_REQUEST
);
const fetchingWeeklyAdoptionTimelineC4Succeeded = createAction(
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_SUCCEEDED
);
const fetchingWeeklyAdoptionTimelineC4Failed = createAction(
  FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_FAILED
);

function* fetchWeeklyAdoptionTimelineC4Saga(action) {
  let { from, to } = action.payload;

  let url = buildUrl(`${METRICS_BASE_URL}/weekly-adoption/timeline`);

  const fetchWeeklyAdoptionTimelineC4API = () => {
    const params = {
      category: "CATEGORY_75_100",
    };

    const data = {
      from: from,
      to: to,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: data,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchWeeklyAdoptionTimelineC4API);
    yield put(fetchingWeeklyAdoptionTimelineC4Succeeded(response));
  } catch (error) {
    yield put(fetchingWeeklyAdoptionTimelineC4Failed(error));
  }
}

// wau adoption list
export const fetchWeeklyAdoptionList = createAction(
  FETCHING_WEEKLY_ADOPTION_LIST_REQUEST
);
const fetchingWeeklyAdoptionListSucceeded = createAction(
  FETCHING_WEEKLY_ADOPTION_LIST_SUCCEEDED
);
const fetchingWeeklyAdoptionListFailed = createAction(
  FETCHING_WEEKLY_ADOPTION_LIST_FAILED
);

function* fetchWeeklyAdoptionListSaga(action) {
  let { from, to, category, page, limit } = action.payload;

  let url = buildUrl(`${METRICS_BASE_URL}/weekly-adoption/list`);

  const fetchWeeklyAdoptionListAPI = () => {
    const params = {
      category,
      page,
      limit,
    };

    const data = {
      from,
      to,
    };

    return axios({
      method: "POST",
      url: url,
      params: params,
      data: data,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchWeeklyAdoptionListAPI);
    yield put(fetchingWeeklyAdoptionListSucceeded(response));
  } catch (error) {
    yield put(fetchingWeeklyAdoptionListFailed(error));
  }
}

export default function* adoptionMetricsSaga() {
  yield takeLatest(FETCHING_ADOPTION_ACCOUNTS, fetchAdoptionAccountsSaga);
  yield takeLatest(FETCHING_TOTAL_NUMBER_OF_ACCOUNTS, fetchTotalAccountsSaga);
  yield takeLatest(
    FETCHING_TOTAL_NUMBER_OF_ACCOUNTS_TIMELINE,
    fetchTotalAccountsTimelineSaga
  );
  yield takeLatest(FETCHING_NEW_ACCOUNTS, fetchNewAccountsSaga);
  yield takeLatest(FETCHING_CHURNED_ACCOUNTS, fetchChurnedAccountsSaga);
  yield takeLatest(FETCHING_TRIAL_ACCOUNTS, fetchTrialAccountsSaga);
  yield takeLatest(FETCHING_SUSPENDED_ACCOUNTS, fetchSuspendedAccountsSaga);
  yield takeLatest(FETCHING_TERMINATED_ACCOUNTS,fetchTerminatedAccountsSaga);
  yield takeLatest(FETCHING_TOTAL_USERS, fetchTotalUsersSaga);
  yield takeLatest(FETCHING_TOTAL_ASSETS, fetchTotalAssetsSaga);
  yield takeLatest(FETCHING_TOTAL_COLLECTIONS, fetchTotalCollectionsSaga);
  yield takeLatest(FETCHING_TOTAL_STREAMS, fetchTotalStreamsSaga);
  yield takeLatest(FETCHING_DAILY_ACTIVE_USERS, fetchDailyActiveUsersSaga);
  yield takeLatest(
    FETCHING_DAILY_ACTIVE_USERS_TIMELINE,
    fetchDailyActiveUsersTimelineSaga
  );
  yield takeLatest(FETCHING_WEEKLY_ACTIVE_USERS, fetchWeeklyActiveUsersSaga);
  yield takeLatest(
    FETCHING_WEEKLY_ACTIVE_USERS_TIMELINE,
    fetchWeeklyActiveUsersTimelineSaga
  );
  yield takeLatest(FETCHING_MONTHLY_ACTIVE_USERS, fetchMonthlyActiveUsersSaga);
  yield takeLatest(
    FETCHING_MONTHLY_ACTIVE_USERS_TIMELINE,
    fetchMonthlyActiveUsersTimelineSaga
  );
  yield takeLatest(FETCHING_INTEGRATIONS, fetchIntegrationsSaga);
  yield takeLatest(FETCHING_STREAM_CREATION, fetchStreamCreationSaga);
  yield takeLatest(FETCHING_STREAM_CREATION, fetchAssetCreationSaga);
  yield takeLatest(FETCHING_STREAM_CREATION, fetchCollectionCreationSaga);
  yield takeLatest(FETCHING_ASSET_VIEWING, fetchAssetViewingSaga);
  yield takeLatest(FETCHING_ASSET_SHARING, fetchAssetSharingSaga);
  yield takeLatest(
    FETCHING_FLITEVIEW_EMAIL_OPEN_RATE_REQUEST,
    fetchEmailOpenRateSaga
  );
  yield takeLatest(
    FETCHING_FLITEVIEW_LINK_OPEN_RATE_REQUEST,
    fetchLinkOpenRateSaga
  );
  yield takeLatest(
    FETCHING_FLITEVIEW_AVERAGE_TIME_SPENT_REQUEST,
    fetchAverageTimeSpentSaga
  );

  yield takeLatest(
    FETCHING_FLITEVIEW_PERSONALISED_LINKS_REQUEST,
    fetchPersonalisedLinksSaga
  );

  yield takeLatest(
    FETCHING_FLITEVIEW_ANONYMOUS_LINKS_REQUEST,
    fetchAnonymousLinksSaga
  );

  yield takeLatest(FETCHING_FLITEVIEW_SESSIONS_REQUEST, fetchSessionsSaga);
  yield takeLatest(
    FETCHING_FLITEVIEW_SESSIONS_PERSONALISED_REQUEST,
    fetchPersonalisedSessionsSaga
  );
  yield takeLatest(
    FETCHING_FLITEVIEW_SESSIONS_ANONYMOUS_REQUEST,
    fetchAnonymousSessionsSaga
  );
  yield takeLatest(
    FETCHING_FLITEVIEW_SESSIONS_UNIQUE_VISITORS_REQUEST,
    fetchUniqueVisitorsSaga
  );
  yield takeLatest(
    FETCHING_FLITEVIEW_SESSIONS_COMPLETION_REQUEST,
    fetchSessionsCompletionSaga
  );
  yield takeLatest(FETCHING_TOTAL_LEADS_REQUEST, fetchTotalLeadsSaga);
  yield takeLatest(
    FETCHING_WEEKLY_ADOPTION_MATRIX_REQUEST,
    fetchWeeklyAdoptionMatrixSaga
  );
  yield takeLatest(
    FETCHING_WEEKLY_ADOPTION_TIMELINE_C1_REQUEST,
    fetchWeeklyAdoptionTimelineC1Saga
  );
  yield takeLatest(
    FETCHING_WEEKLY_ADOPTION_TIMELINE_C2_REQUEST,
    fetchWeeklyAdoptionTimelineC2Saga
  );
  yield takeLatest(
    FETCHING_WEEKLY_ADOPTION_TIMELINE_C3_REQUEST,
    fetchWeeklyAdoptionTimelineC3Saga
  );
  yield takeLatest(
    FETCHING_WEEKLY_ADOPTION_TIMELINE_C4_REQUEST,
    fetchWeeklyAdoptionTimelineC4Saga
  );
  yield takeLatest(
    FETCHING_WEEKLY_ADOPTION_LIST_REQUEST,
    fetchWeeklyAdoptionListSaga
  );
}